// src/components/PageHead.js
import React from 'react';

/**
 * 页面标题栏：标题 + 右侧操作区
 * 说明：各页面标题下方的说明性注释统一不再展示（门户页卡片文案不受影响）
 */
const PageHead = ({ title, extra, onTitleClick }) => (
  <div className="page-head">
    <div>
      <div
        className="page-head-title"
        onClick={onTitleClick}
        style={onTitleClick ? { cursor: 'pointer', userSelect: 'none' } : undefined}
      >{title}</div>
    </div>
    {extra ? <div className="page-head-extra">{extra}</div> : null}
  </div>
);

export default PageHead;